import { CommonModule } from '@angular/common';
import { 
  ChangeDetectionStrategy, 
  Component, 
  OnDestroy, 
  OnInit 
} from '@angular/core';
import { StyleClassModule } from 'primeng/styleclass';
import { NavSignalsService } from '../../services/nav.signals.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { environment } from '@environments/environment';
import { Router, RouterModule } from '@angular/router';
import { AppSettingsService } from '@shared/services/app-settings/app-settings.service';
import { SignalsService } from '@shared/services/signals/signals.service';
import { Subscription } from 'rxjs';
import { VersionService } from 'app/features/about/children/version/version.service';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CrewDetail } from 'app/features/flights/flight-detail/model/crew-detail';
import { AdminService } from 'app/features/admin/admin.service';
import { AppService } from 'app/app.service';
import { BadgeModule } from 'primeng/badge';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    CommonModule,
    StyleClassModule,
    NavMenuComponent,
    RouterModule,
    OverlayPanelModule,
    BadgeModule
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent implements OnInit, OnDestroy {

  version: string = environment.appVersion;
  
  appSettingsInit?: Subscription;
  //initVersionData?: Subscription;

  sidebarMaskVisible = this.navSignalsService.sidebarMaskVisible$;
  isAcitveEmpNumAdmin = this.signalService.isEumulatingEmpNumActive$();
  emulatedPilot?: CrewDetail;


  constructor(
    public navSignalsService: NavSignalsService,
    private appSettings: AppSettingsService,
    public signalService: SignalsService,
    // private versionService: VersionService,
    private adminService: AdminService,
    public appService: AppService,
    private route: Router

  ) {}

  ngOnInit(): void {
    this.loadAppSettings();
    // this.initializerVersionData();
    this.sidebarMaskVisible.set(false);
  }

  loadAppSettings(): void {
    this.appSettingsInit = this.appSettings.getUserSettings().subscribe({
      next: (settings) => {
        this.signalService.defaultTabItem$.set(settings.dashboardViewDefault);
      }
    });
  }

  // initializerVersionData(): void {
  //   this.versionService.getAboutBadgeValue();
    // this.initVersionData = this.versionService.initializeVersionData().subscribe({
    //   next: () => {
    //     this.versionService.getAboutBadgeValue();
    //   }
    // });
  // }

  //If Admin get emulated pilot info
  getEmulatedPilotInfo(): void {
    const emulatedPilot = localStorage.getItem('emulatedPilot');
    if (emulatedPilot) {
      const _emulatedPilot = JSON.parse(emulatedPilot);
      this.emulatedPilot = _emulatedPilot.response[0];
    }
  }

  //Reset emulation and return to own account
  resetEmulatedPilot(){
    this.adminService.resetEmulatedPilot();
    this.route.navigate(['/flights']);
  }

  toggleSidebarMask(): void {
    this.sidebarMaskVisible.set(!this.sidebarMaskVisible());
  }

  ngOnDestroy(): void {
    this.appSettingsInit?.unsubscribe();
    //this.initVersionData?.unsubscribe();
  }
}
